module.exports = __webpack_public_path__ + "media/images/review/reviewer-ico-image-c91409c2d3b8609b4f1de999aeb884d4.png";